export const LINKS = {
  thinkingships: "https://thinkingships.ai",
  thinkingshipsDemo: "https://demo.thinkingships.ai",
  beehiiv: "https://x1025.beehiiv.com/",
  rss: "https://rss.beehiiv.com/feeds/pYIVah8kBL.xml",
};

export const BEEHIIV_FORM_ID = "cefa041d-3fc3-4f9d-840e-55fb616e1a29";

export const STAGES = [
  { k: "01", label: "Today", title: "Today’s ships are built around life onboard.", text: "Bedrooms, kitchens and living quarters take up space." },
  { k: "02", label: "No one onboard", title: "More room for cargo.", text: "Take away the living quarters. Give that space to the job the ship is built for." },
  { k: "03", label: "Ship and shore", title: "The ship works. People stay in charge.", text: "Onboard systems navigate and run the machinery. Mariners in the Remote Operations Center supervise, handle calls and step in when needed." },
  { k: "04", label: "Connected fleet", title: "A whole fleet. Connected to shore.", text: "Each ship runs its own systems. Mariners ashore see the fleet and help where they’re needed." },
];

export const FOUNDERS = [
  {
    id: "hash",
    name: "Hash",
    full: "Harshvardhan",
    side: "The ship",
    tags: ["Time at sea", "Ship operations", "Ship management", "Underwriting", "MIT engineering"],
    bio: [
      "Hash spent a decade at sea as a navigating officer, superintendent, commercial operator and underwriter, across ship operations, ship management and the business of shipping.",
      "He then earned an engineering degree from MIT and spent another decade building tools across logistics, supply chain and robotics. He writes the x1025 Logbook.",
    ],
    links: [
      { label: "hash39.com", href: "https://hash39.com/" },
      { label: "LinkedIn", href: "https://www.linkedin.com/in/h6239/" },
    ],
    portrait: null,
  },
  {
    id: "kelp",
    name: "Kelp",
    full: "Avikalp Kumar Gupta",
    side: "The machine",
    tags: ["Physical AI", "Reliable AI", "Human–computer interaction", "IIT", "Microsoft Research"],
    bio: [
      "Kelp is an IIT-trained technologist and former Microsoft Research fellow holding patents in Physical AI, with over a decade building intelligent systems at scale.",
      "His work spans Physical AI, reliable AI and human–computer interaction.",
    ],
    links: [
      { label: "avikalpg.github.io", href: "https://avikalpg.github.io" },
      { label: "LinkedIn", href: "https://www.linkedin.com/in/avikalp-gupta" },
    ],
    portrait: null,
  },
];
